<img [src]="assetPath" />
